const input = {
  parent: document.querySelectorAll(".js-input-all"),
  child: document.querySelectorAll(".js-input-all-child")
}

if (input.parent && input.child) {
  input.parent.forEach((parent)=>{
    try {
      const category: string | undefined = (parent as HTMLElement).dataset.all;
      parent.addEventListener("change", ()=>{
        if ((parent as HTMLInputElement).checked) {
          input.child.forEach((child)=>{
            if ((child as HTMLElement).dataset.all === category) {
              (child as HTMLInputElement).checked = true;
            }
          })
        } else {
          input.child.forEach((child)=>{
            if ((child as HTMLElement).dataset.all === category) {
              (child as HTMLInputElement).checked = false;
            }
          })
        }
      })
    } catch(e) {
      console.log(e);
    }
  })
  console.log("");
}
